import styled from '@emotion/styled'
import Button from 'portal-modules/common/components/Button'
import { css } from '@emotion/core'
import {
  StyledModalDiv,
  StyledWrapper,
} from 'portal-modules/common/components/modals/rp-modal'

export const ReskinPopUpHeadingTitle = styled('h3')`
  fontfamily: ${({ theme }) => theme.fonts.body};
  font-weight: 700;
  font-size: 21px;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.button_secondary.color};
  margin: ${({ customMargin }) => customMargin || '40px 48px 24px 46px'};
  display: flex;
  justify-content: flex-start;
  @media only screen and (max-width: 768px) {
    margin: ${({ mediaMargin }) => mediaMargin || '24px 16px 24px 16px'};
  }
`

export const ReskinPopUpSubHeadingTitle = styled('h6')`
  fontfamily: ${({ theme }) => theme.fonts.body};
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.gray.gray4};
  height: ${({ customHeight }) => `${customHeight}px` || '21px'};
  margin: ${({ customMargin }) => customMargin || '0 48px 16px 46px'};
  display: flex;
  justify-content: flex-start;
  @media only screen and (max-width: 768px) {
    margin: ${({ mediaMargin }) => mediaMargin || '0 16px 24px 16px'};
  }
`

export const ReskinPopUpHeadingDescription = styled('p')`
  font-weight: 400;
  font-size: 13px;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.gray.mediumlight};
  margin: ${({ customMargin }) => customMargin || '0 48px'};
  height: ${({ image_url, customHeight, noHeight }) =>
    noHeight ? 'none' : image_url ? `${customHeight}px` : `${customHeight}px`};
  overflow-y: auto;
  overflow-x: auto;
  @media only screen and (max-width: 768px) {
    margin: ${({ mediaMargin }) => mediaMargin || '0 16px'};
  }
`
export const ReskinPopUpSubHeading = styled('p')`
  font-weight: 400;
  font-size: 13px;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.gray.mediumlight};
  margin: ${({ customMargin }) => customMargin || '0 48px'};
  height: ${({ image_url, customHeight, noHeight }) =>
    noHeight ? 'none' : image_url ? `${customHeight}px` : `${customHeight}px`};
  overflow-y: auto;
  overflow-x: auto;
  @media only screen and (max-width: 768px) {
    margin: ${({ mediaMargin }) => mediaMargin || '0 16px'};
  }
`

export const StyledReskinModalDiv = styled(StyledModalDiv)`
  position: absolute;
  width: ${({ isWideDialog, customWidth }) => (isWideDialog ? customWidth || '600px' : '330px')};
  height: ${({ isWideDialog, customHeight }) =>
    isWideDialog ? customHeight || '100vh' : '300px'};
  max-height: 848px;
  background: ${({ theme, hasBackground }) => hasBackground && theme.mode.isDark ? theme.brown.brown3 : theme.mode.modal_background};
  backdrop-filter: blur(20px);
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1);
  border-radius: ${({ theme }) => theme.mode.card_border_radius};
  overflow: auto;
  &.remove-pad {
    padding-bottom: 0;
  }

  @media only screen and (max-width: 744px) {
    width: 100vw;
    border-radius: ${({ isWideDialog, theme }) => isWideDialog && `${theme.mode.card_border_radius} ${theme.mode.card_border_radius} 0 0`};
    margin: 0;
    height: 100%;
  }
`

export const StyledReskinModalWrapper = styled(StyledWrapper)`
  display: flex;
  width: ${({ isWideDialog, customWidth }) => (isWideDialog ? customWidth || '600px' : '330px')};
  height: ${({ isWideDialog, customHeight }) => (isWideDialog ? customHeight || '90vh' : '300px')};
  @media only screen and (max-width: 744px) {
    width: ${({ isWideDialog }) => isWideDialog && '100vw'};
    max-width: none;
    max-height: 100vh;
    margin: 0;
    height: ${({ isWideDialog }) => isWideDialog && '100%'};
  }
`
export const StyledReskinModalButtonWrapper = styled('div')`
  position: fixed;
  bottom: 40px;
  width: 100%;
  text-align: center;
`
export const StyledReskinModalButton = styled(Button)`
  @media only screen and (max-width: 768px) {
    width: auto;
    min-width: 100px;
    height: 48px;
    padding: 14px 28px;
    font-size: 16px;
  }
`
export const StyledReskinModalOutsideContent = styled('div')`
  margin-top: 310px;
  margin-left: 125px;
`
export const ReskinPopUpImageWrapper = styled('div')`
  width: 100%;
  height: 280px;
  border-radius: 24px 24px 0 0;
  background-image: ${({ image_url }) => `url(${image_url})`};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`

export const StyledFlex = styled('div')`
  max-height: 700px;
  overflow: auto;
`
export const StyledTextDetails = styled('ul')`
  color: ${({ theme }) => theme.gray.dark};
  list-style-type: none;
  margin: 0 0 24px 0;
  padding: 0;
`
export const StyledDivBtn = styled('div')`
  display: flex;
  justify-content: center;
`

export const StyledFlexModalBtn = styled('div')`
  display: flex;
  justify-content: center;
`
export const StyledFlexModalText = styled('p')`
  color: ${({ theme }) => theme.gray.dark};
  font-size: 13px;
  line-height: 24px;
  list-style-type: none;
  margin: 0 0 24px 0;
  padding: 0;

  @media only screen and (max-width: 280px) {
    font-size: 10px;
    line-height: 15px;
    padding: 0px;
  }
  @media only screen and (min-width: 320px) and (max-width: 374px) {
    font-size: 8px;
    line-height: 0px;
  }
  @media only screen and (min-width: 375px) and (max-width: 716px) {
    font-size: 14px;
    line-height: 15px;
  }
  @media screen and (min-width: 820px) and (max-width: 1024px) {
    font-size: 18px;
    line-height: 34px;
  }
`
export const StyledFlexModalFooterText = styled('p')`
  color: ${({ theme }) => theme.gray.dark};
  font-size: 13px;
  line-height: 24px;
  list-style-type: none;
  padding: 6px;
  @media only screen and (max-width: 280px) {
    font-size: 8px;
    line-height: 24px;
    padding: 1px;
  }
  @media only screen and (min-width: 320px) and (max-width: 374px) {
    font-size: 8px;
    line-height: 14px;
    padding: 0px;
  }
  @media only screen and (min-width: 375px) and (max-width: 716px) {
    font-size: 14px;
    line-height: 21px;
    padding: 0px;
  }
`
export const StyledFlexModalButton = css`
  padding: 16px;
`
export const StyledFlexModalTextFontWeight = css`
  font-weight: bold;
  @media only screen and (min-width: 320px) and (max-width: 374px) {
    line-height: 16px;
  }
  @media only screen and (min-width: 375px) and (max-width: 716px) {
    font-size: 14px;
  }
`

export const StyledFlexModalTitle = styled('p')`
  width: 37%;
  position: fixed;
  top: 0;
`

export const StyledFlexModalTextFont = css`
  font-weight: bold;
  font-size: 24px;
  @media only screen and (max-width: 280px) {
    font-size: 14px;
    line-height: 15px;
    padding: 1px;
  }
  @media only screen and (min-width: 320px) and (max-width: 374px) {
    font-size: 8px;
  }
  @media only screen and (min-width: 375px) and (max-width: 716px) {
    font-size: 14px;
  }
`
export const StyledFlexModalImage = styled('p')`
  width: 40%;
  position: fixed;
  top: -18px;
  right : 50px;
  @media only screen and (max-width: 320px) {
    width: 30%;
    top: -16px;
  }
  @media only screen and (min-width: 321px) and (max-width: 374px) {
    width: 31%;
    top: -16px;
  }
  @media only screen and (min-width: 321px) and (max-width: 374px) {
    width: 31%;
    top: -16px;
  }
  @media only screen and (min-width: 375px) and (max-width: 389px) {
    width: 31%;
    top: -16px;
  }
  @media only screen and (min-width: 390px) and (max-width: 413px) {
    width: 40%;
    top: -18px;
    right: 43px
  }
  @media only screen and (min-width: 540px) and (max-width: 716px) {
    width: 40%;
  }
  @media screen and (min-width: 716px) and (max-width: 819px){
    width: 38%;
    }
    @media screen and (min-width: 820px) and (max-width: 1024px){
      width: 47%;
      }
  @media screen and (min-width: 1025px) and (max-width: 1280px){
    width: 44%;
    }
}
`
export const StyledImage = styled('img')`
  width: 242px;
  height: 454px;
  @media only screen and (max-width: 280px) {
    width: 118px;
    height: 348px;
  }
  @media only screen and (min-width: 281px) and (max-width: 320px) {
    width: 133px;
    height: 348px;
  }
  @media only screen and (min-width: 321px) and (max-width: 359px) {
    width: 133px;
    height: 304px;
  }
  @media only screen and (min-width: 360px) and (max-width: 374px) {
    width: 146px;
    height: 371px;
  }
  @media only screen and (min-width: 375px) and (max-width: 389px) {
    width: 152px;
    height: 387px;
  }
  @media only screen and (min-width: 390px) and (max-width: 413px) {
    width: 180px;
    height: 425px;
  }
  @media only screen and (min-width: 414px) and (max-width: 539px) {
    width: 201px;
    height: 387px;
  }
  @media only screen and (min-width: 540px) and (max-width: 716px) {
    width: 236px;
    height: 387px;
  }
  @media screen and (min-width: 716px) and (max-width: 819px) {
    width: 231px;
    height: 398px;
  }
  @media screen and (min-width: 820px) and (max-width: 1024px) {
    width: 275px;
    height: 495px;
  }
  @media screen and (min-width: 1025px) and (max-width: 1280px) {
    width: 262px;
    height: 549px;
  }
`
export const StyledFlexModaldiv = styled('div')`
  height: 700px;
  overflow-x: auto;
`

export const StyledFlexTextColor = styled('p')`
  color: ${({ theme }) => theme.purple.light};
  font-size: 16px;
  line-height: 24px;
  list-style-type: none;
  padding: 0;
`

export const StyledViewLink = styled('a')`
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
  font-weight: 0;
  margin: 14px 1px;
  color: ${({ theme }) => theme.blue.system_blue};
  text-decoration: underline;
  @media only screen and (max-width: 280px) {
    font-size: 8px;
  }
  @media only screen and (min-width: 320px) and (max-width: 374px) {
    font-size: 8px;
  }
  @media only screen and (min-width: 375px) and (max-width: 716px) {
    font-size: 14px;
  }
`

export const StyledButtonBottomDiv = styled('div')`
  position: fixed;
  bottom: 40px;
  width: 100%;
  text-align: center;
  right: 0;
  button {
    @media only screen and (max-width: 768px) {
      width: auto;
      min-width: 100px;
      height: 48px;
      padding: 14px 28px;
      font-size: 16px;
    }
  }
`
